// 揭晓覆盖层（EP-007-S3 / 主架构 §9）。
// role=dialog + aria-modal + Esc 关闭 + 进入即聚焦（基础焦点管理）。
// 关闭即视为「确认」——礼物已在 inventory 落盘，直接进空间（先入库后演出，中断不丢礼物）。
import { useEffect, useRef } from 'react';
import type { RevealSnapshot } from '../runtime/sequencer';
import { RevealSequence } from './RevealSequence';

interface RevealOverlayProps {
  snapshot: RevealSnapshot;
  onDone: () => void;
}

export function RevealOverlay({ snapshot, onDone }: RevealOverlayProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onDone();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onDone]);

  return (
    <div
      className="reveal-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="揭晓小狗带回了什么"
      tabIndex={-1}
      ref={ref}
    >
      <RevealSequence snapshot={snapshot} onDone={onDone} />
    </div>
  );
}
